import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Divider,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { validateOnFlow } from "../../../utils/validate";
import { isEmpty } from "lodash";

const DatePattern = (props) => {
  const { t } = useTranslation();
  const {
    openModal,
    docPath,
    okHandler,
    cancelHandler,
    onChangeHandler,
    testDateHandler,
    datePattern,
    dpNetworkCallMessage,
    valid,
    sourceType,
    handleClose,
    setOpenModal,
    loading
  } = props;
  const fieldLabel = t("TIT_DATE_FORMATTER")?.split(' ')
  fieldLabel?.splice(1,1,t('FORMAT')) //Temporarily getting required string from two localized String. Added This Srting requirement in BG-8538 
  return (
    <>
      <Dialog open={openModal} maxWidth={"lg"} fullWidth={true} onClose={() => setOpenModal(false)}>
        <DialogTitle className="dialog-header">
          <div className="title">{t("DIAG_DATE_PATTERN_BUILDER_TIT")}</div>
          <div className="description">
            
          </div>
        </DialogTitle>
        <DialogContent
          className="dialog-content"
          sx={{ height: "580px", maxHeight: "580px", overflow: "hidden" }}
          dividers>
          <Grid container spacing={1} columns={13}>
            <Grid item xs={8}>
              {docPath ? (
                <iframe
                  className="docFrame"
                  style={{ height: "93%" }}
                  title="datePattern"
                  src={docPath}></iframe>
              ) : (
                ""
              )}
            </Grid>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              style={{ padding: "8px" }}
            />
            <Grid item xs={4} style={{ height: "80vh" }}>
              <div>
                <div
                  style={{ marginTop: "10px", marginLeft: "1rem" }}
                  className="dialog-header">
                    <div className="title">{t("DIAG_DATE_PATTERN_BUILDER_DESC")}</div>
                </div>
                <div style={{ marginTop: "20px" }}>
                  <Box className="dp-actions">
                    <TextField
                      variant="outlined"
                      size="small"
                      autoFocus={true}
                      label={fieldLabel?.join(' ')}
                      className={"width-75"}
                      name={"DATEPATTERN"}
                      value={datePattern}
                      error={!valid}
                      onChange={(e) => {
                        onChangeHandler(e.target.value);
                      }}
                    />
                    <Button
                      size="small"
                      onClick={() => {
                        testDateHandler("fromModal", datePattern);
                      }}
                      variant={"outlined"}>
                      {loading ? <CircularProgress size={"16px"}/> : t("BTN_TEST_IT")}
                    </Button>
                  </Box>
                  {/* <Box className="dp-actions" style={{ width: "430px",minWidth:'380px' }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      multiline
                      label={t("LBL_TEST_RESULTS")}
                      className={"width-75"}
                      name={"TESTRESULTS"}
                      value={dpNetworkCallMessage}
                    />
                  </Box> */}
                  <Box className="dp-actions dp-test-date">
                    <TextField
                      variant="outlined"
                      size="small"
                      multiline
                      label={t("LBL_TEST_RESULTS")}
                      sx={{ flex: 1, minWidth: 0 }}
                      name={"TESTRESULTS"}
                      value={dpNetworkCallMessage}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Box>
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-header">
          {sourceType === "sessionWorkflowModal" && <Button 
            size="small" 
            onClick={()=>{
              cancelHandler();
            }} 
            variant={"outlined"} 
          >
            {t("BTN_BACK")}
          </Button> }
          {sourceType === "sessionWorkflowModal" && <Button 
            size="small" 
            onClick={()=>{
              okHandler(false);
            }} 
            variant={"outlined"} 
            disabled={!valid}
          >
            {t("BTN_NEXT")}
          </Button>}
          <Button size="small" 
            onClick={()=>{
              okHandler(true);
              if(sourceType === "sessionWorkflowModal") handleClose()
            }} 
            variant={"outlined"} 
            disabled={!valid}
          >
            { sourceType === "sessionWorkflowModal" ? t("BTN_FINISH") : t("APPLY_CNGS").split(' ').shift()}
          </Button>
          <Button size="small" onClick={cancelHandler} variant={"outlined"}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DatePattern;
